import { shuffleNewArray } from '../../../../lib/utilityFunctions';
import { GOBLINS_PER_LEVEL } from '../../constants';

let curriculum = {};
export const setCurriculum = (c) => { curriculum = c; };
export const getCurriculum = () => curriculum;

let audioMap = {};
export const setAudioMap = (a) => { audioMap = a; };
export const getAudioMap = () => audioMap;

const checkToastValidity = (toastToCheck, toasts) => {
  if (toastToCheck.similarGraphems) {
    return !toasts.some(toast => toastToCheck.similarGraphems.some(questionId => toast.questionId === questionId));
  }
  return true;
};

export const getToasts = (levelIndex) => {
  const level = levelIndex + 1;
  let toasts;
  const newToasts = shuffleNewArray((curriculum.levels.find(item => item.levelId === level).standardItem));
  toasts = [];
  for (let i = 0, l = newToasts.length; i < l; i++) {
    // 4 new toasts out of the 6 total if level is not 1
    if (level !== 1 && toasts.length === 4) {
      break;
    }
    if (checkToastValidity(newToasts[i], toasts)) {
      toasts = [
        ...toasts,
        newToasts[i],
      ];
    }
  }
  if (level !== 1) {
    const oldToasts = shuffleNewArray(curriculum.levels.reduce((prev, item) => {
      if (item.levelId < level) {
        return prev.concat(item.standardItem);
      }
      return prev;
    }, []));
    for (let i = 0, l = oldToasts.length; i < l; i++) {
      if (toasts.length === 6) {
        break;
      }
      if (checkToastValidity(oldToasts[i], toasts)) {
        toasts = [
          ...toasts,
          oldToasts[i],
        ];
      }
    }
  }
  const phonemes = audioMap && audioMap.phonemes;
  toasts = toasts.map(toast => ({ ...toast, audiofile: phonemes[toast.questionId] }));
  // final shuffle and return
  return shuffleNewArray(toasts);
};

// used in shuffleGoblinArray because filter function isn't allowed in while-loop
const candidatesForShuffle = (remainingChoices, shuffledArray) => {
  const lastIndex = shuffledArray.length - 1;
  return remainingChoices.filter(({ questionId }) => (
    questionId !== (shuffledArray[lastIndex] || {}).questionId
    && questionId !== (shuffledArray[lastIndex - 1] || {}).questionId
  ));
};

const shuffleGoblinArray = (array) => {
  const targetLength = array.length;
  let remainingChoices = [...array];
  let shuffledArray = [];
  while (shuffledArray.length < targetLength) {
    const candidates = candidatesForShuffle(remainingChoices, shuffledArray);
    if (candidates.length === 0) {
      shuffledArray = [];
      remainingChoices = [...array];
    } else {
      const elementToAdd = candidates[Math.floor(Math.random() * candidates.length)];
      shuffledArray.push(elementToAdd);
      remainingChoices.splice(remainingChoices.findIndex(e => e.questionId === elementToAdd.questionId), 1);
    }
  }
  return shuffledArray;
};

export const getGoblins = (toasts) => {
  let id = 0;
  return shuffleGoblinArray(toasts.reduce((goblins, toast) => [
    ...goblins,
    {
      ...toast,
      id: id++,
    },
    {
      ...toast,
      id: id++,
    },
    {
      ...toast,
      id: id++,
    },
  ], [])).slice(0, GOBLINS_PER_LEVEL);
};

export const getLevelCurriculum = (level) => {
  const toasts = getToasts(level);
  const goblins = getGoblins(toasts);
  return {
    level,
    toasts,
    goblins,
  };
};
